import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
} from "react";
import {KeyboardLayout} from "../../modules/keyboard/types/KeyboardLayout";
import {KeyboardContextProps} from "../../modules/keyboard/interfaces/KeyboardContextProps";
import { debugLog } from "../../utils/debug";

const KeyboardContext = createContext<KeyboardContextProps | null>(null);

export const KeyboardProvider: React.FC<{ children: ReactNode }> = ({
                                                                        children,
                                                                    }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState("");
    const [layout, setLayout] = useState<KeyboardLayout>("letters");
    const [activeInputId, setActiveInputId] = useState<string | null>(null);
    const [activeInputRef, setActiveInputRef] = useState<HTMLElement | null>(null);
    const [onChangeCallback, setOnChangeCallback] = useState<
        ((v: string) => void) | null
    >(null);

    const openKeyboard = (
        initialValue = "",
        onChange?: (v: string) => void,
        inputId?: string,
        inputRef?: HTMLElement
    ) => {
        debugLog('inputId ', inputId,initialValue, onChange, inputRef);
        setOnChangeCallback(null);
        setIsOpen(true);
        setValue(initialValue);
        if (onChange) setOnChangeCallback(() => onChange);
        setActiveInputId(inputId || null);
        setActiveInputRef(inputRef || null);
    };

    const closeKeyboard = () => {
        setIsOpen(false);
        setActiveInputRef(null);
        setActiveInputId(null);
        setOnChangeCallback(null);
    };

    useEffect(() => {
        if (isOpen && onChangeCallback) {
            onChangeCallback(value);
        }
    }, [value, isOpen, onChangeCallback]);

    return (
        <KeyboardContext.Provider
            value={{
                isOpen,
                value,
                setValue,
                openKeyboard,
                closeKeyboard,
                layout,
                setLayout,
                activeInputId,
                activeInputRef,
            }}
        >
            {children}
        </KeyboardContext.Provider>
    );
};

export const useKeyboard = () => {
    const ctx = useContext(KeyboardContext);
    if (!ctx) throw new Error("useKeyboard must be used inside KeyboardProvider");
    return ctx;
};
